import { lookupCard } from "../../content/index.js";
import type { ApplyEffectContext } from "./effectContext.js";

export function startRepeatPlay(
  ctx: ApplyEffectContext,
  times: 2 | 3,
): ApplyEffectContext {
  const hasAction = ctx.run.hand.some((card) => lookupCard(card.cardId)?.type === "action");
  if (!hasAction) return ctx;
  return {
    ...ctx,
    run: {
      ...ctx.run,
      pendingChoice: {
        kind: "meeting",
        sourceInstanceId: ctx.sourceInstanceId,
        targetInstanceId: null,
        times,
        round: 1,
      },
    },
  };
}
